export const NUMBER_REGEX = /^\d+$/;

export const BACKSPACE_KEY = 'Backspace';

export const SEARCH_TERM_LIMIT = 11;

export const INVALID_MESSAGE = 'Digite um CPF ou telefone com DDD';

export const DESKTOP_CARD_HEIGHT = 109;
export const MOBILE_NO_CHECKIN_CARD_HEIGHT = 150;
export const MOBILE_CARD_HEIGHT = 235;

export const TAB_GROUP_HEIGHT = 41;
export const DESKTOP_TABLE_HEADER = 43;
export const MOBILE_HEADER_COLLAPSED_HEIGHT = 151;

const BANNER_UPGRADE_TWO_LINES_HEIGHT = 90;
const BANNER_UPGRADE_THREE_LINES_HEIGHT = 111;
const BANNER_UPGRADE_MOBILE_LAYOUT_TWO_LINES_HEIGHT = 186;
const BANNER_UPGRADE_MOBILE_LAYOUT_THREE_LINES_HEIGHT = 207;
export const BANNER_UPGRADE_MOBILE_LAYOUT_FOUR_LINES_HEIGHT = 228;

export const BANNER_UPGRADE_WIDTH_THRESHOLDS = [
  { minWidth: 1358, height: BANNER_UPGRADE_TWO_LINES_HEIGHT },
  { minWidth: 1245, height: BANNER_UPGRADE_THREE_LINES_HEIGHT },
  { minWidth: 1085, height: BANNER_UPGRADE_MOBILE_LAYOUT_TWO_LINES_HEIGHT },
  { minWidth: 1024, height: BANNER_UPGRADE_MOBILE_LAYOUT_THREE_LINES_HEIGHT },
  { minWidth: 682, height: BANNER_UPGRADE_TWO_LINES_HEIGHT },
  { minWidth: 569, height: BANNER_UPGRADE_THREE_LINES_HEIGHT },
  { minWidth: 409, height: BANNER_UPGRADE_MOBILE_LAYOUT_TWO_LINES_HEIGHT },
  { minWidth: 0, height: BANNER_UPGRADE_MOBILE_LAYOUT_FOUR_LINES_HEIGHT },
];

const BANNER_PAY_PER_USE_TWO_LINES_HEIGHT = 104;
const BANNER_PAY_PER_USE_THREE_LINES_HEIGHT = 111;
const BANNER_PAY_PER_USE_MOBILE_LAYOUT_TWO_LINES_HEIGHT = 210;
const BANNER_PAY_PER_USE_MOBILE_LAYOUT_THREE_LINES_HEIGHT = 231;
const BANNER_PAY_PER_USE_MOBILE_LAYOUT_FOUR_LINES_HEIGHT = 252;

export const BANNER_PAY_PER_USE_WIDTH_THRESHOLDS = [
  { minWidth: 1397, height: BANNER_PAY_PER_USE_TWO_LINES_HEIGHT },
  { minWidth: 1219, height: BANNER_PAY_PER_USE_THREE_LINES_HEIGHT },
  { minWidth: 1118, height: BANNER_PAY_PER_USE_MOBILE_LAYOUT_TWO_LINES_HEIGHT },
  { minWidth: 1024, height: BANNER_PAY_PER_USE_MOBILE_LAYOUT_THREE_LINES_HEIGHT },
  { minWidth: 776, height: BANNER_PAY_PER_USE_TWO_LINES_HEIGHT },
  { minWidth: 615, height: BANNER_PAY_PER_USE_THREE_LINES_HEIGHT },
  { minWidth: 514, height: BANNER_PAY_PER_USE_MOBILE_LAYOUT_TWO_LINES_HEIGHT },
  { minWidth: 352, height: BANNER_PAY_PER_USE_MOBILE_LAYOUT_THREE_LINES_HEIGHT },
  { minWidth: 0, height: BANNER_PAY_PER_USE_MOBILE_LAYOUT_FOUR_LINES_HEIGHT },
];
